import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ProfileBar } from "../components/ProfileBar";
import { useProfile } from "../components/ProfileContext";
import { setNavAdvisoryLockout } from "../util/utils";

export function AdminDashboardPage(props) {
	setNavAdvisoryLockout(false);

	let [profile] = useProfile();
	return <div className="adminDashboardPageContainer">
		<h1>Machine Inspection</h1>
		<h2>Admin Tools</h2>
		<Link to="/surveys"><Button variant="warning" className="m-2">Edit Surveys</Button></Link>
		{profile.admin && <>
			<Link to="/componentTypes"><Button variant="warning" className="m-2">Edit Component Types</Button></Link>
		</>}
	</div>
}